(function() {
  let scrollTriggerInstance = null;
  let mediaElement = null;
  let imageContainer = null;

  // Function to create word masking while preserving HTML elements
  function createWordMasking(element) {
    const allWords = [];
    const childNodes = Array.from(element.childNodes);
    const newContent = [];
    
    childNodes.forEach(node => {
      if (node.nodeType === Node.TEXT_NODE) {
        const text = node.textContent.trim();
        if (text) {
          const words = text.split(/\s+/);
          words.forEach((word, wordIndex) => {
            const wordWrapper = document.createElement('span');
            wordWrapper.className = 'word-wrapper';
            wordWrapper.style.overflow = 'hidden';
            wordWrapper.style.display = 'inline-block';
            wordWrapper.style.position = 'relative';
            
            const wordSpan = document.createElement('span');
            wordSpan.textContent = word;
            wordSpan.className = 'word';
            wordSpan.style.display = 'inline-block';
            wordSpan.style.position = 'relative';
            
            wordWrapper.appendChild(wordSpan);
            newContent.push(wordWrapper);
            allWords.push(wordSpan);
            
            // Add space after word (except last word)
            if (wordIndex < words.length - 1) {
              newContent.push(document.createTextNode(' '));
            }
          });
        }
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        // For elements like h1, p - preserve the element but process its children
        const elementTag = node.tagName.toLowerCase();
        const preservedElement = document.createElement(elementTag);
        
        // Copy all attributes
        Array.from(node.attributes).forEach(attr => {
          preservedElement.setAttribute(attr.name, attr.value);
        });
        
        // Process child nodes recursively
        Array.from(node.childNodes).forEach(child => {
          if (child.nodeType === Node.TEXT_NODE && child.textContent.trim()) {
            const words = child.textContent.trim().split(/\s+/);
            words.forEach((word, wordIndex) => {
              const wordWrapper = document.createElement('span');
              wordWrapper.className = 'word-wrapper';
              wordWrapper.style.overflow = 'hidden';
              wordWrapper.style.display = 'inline-block';
              wordWrapper.style.position = 'relative';
              
              const wordSpan = document.createElement('span');
              wordSpan.textContent = word;
              wordSpan.className = 'word';
              wordSpan.style.display = 'inline-block';
              wordSpan.style.position = 'relative';
              
              wordWrapper.appendChild(wordSpan);
              preservedElement.appendChild(wordWrapper);
              allWords.push(wordSpan);
              
              if (wordIndex < words.length - 1) {
                preservedElement.appendChild(document.createTextNode(' '));
              }
            });
          } else if (child.nodeType === Node.ELEMENT_NODE) {
            // Preserve HTML elements like span.image-container
            preservedElement.appendChild(child.cloneNode(true));
          }
        });
        
        newContent.push(preservedElement);
      }
    });
    
    // Clear and rebuild the element
    element.innerHTML = '';
    newContent.forEach(item => {
      element.appendChild(item);
    });
    
    return allWords;
  }

  // Initialize text animation
  function initTextAnimation() {
    if (typeof gsap === 'undefined') {
      setTimeout(initTextAnimation, 100);
      return;
    }

    document.fonts.ready.then(() => {
      const splitElements = document.querySelectorAll('.animated-image-section .split');
      if (!splitElements.length) return;

      splitElements.forEach((splitElement) => {
        gsap.set(splitElement, { opacity: 1 });
        
        // Create word masking
        const words = createWordMasking(splitElement);
        
        if (words.length > 0) {
          // Set initial state - words start masked (translated down)
          gsap.set(words, { y: '100%' });
          
          // Animate words - reveal from bottom to top
          gsap.to(words, {
            duration: 1.2,
            y: '0%',
            stagger: 0.08,
            ease: "power2.out",
          });
        }
      });
    });
  }

  function calculateViewportPosition() {
    const mediaRect = mediaElement.getBoundingClientRect();
    return {
      x: window.innerWidth / 2 - (mediaRect.left + mediaRect.width / 2),
      y: window.innerHeight / 2 - (mediaRect.top + mediaRect.height / 2) - window.innerHeight * 0.3
    };
  }

  function calculateInitialPosition() {
    if (!mediaElement) return { x: 0, y: 0 };
    if (!imageContainer) return calculateViewportPosition();

    if (!imageContainer.offsetWidth || !imageContainer.offsetHeight ||
        !mediaElement.offsetWidth || !mediaElement.offsetHeight) {
      return null;
    }

    void imageContainer.offsetHeight;
    void mediaElement.offsetHeight;
    
    const imageRect = imageContainer.getBoundingClientRect();
    const mediaRect = mediaElement.getBoundingClientRect();
    
    if (!imageRect.width || !imageRect.height || !mediaRect.width || !mediaRect.height) {
      return null;
    }
    
    const x = (imageRect.left + imageRect.width / 2) - (mediaRect.left + mediaRect.width / 2);
    const y = (imageRect.top + imageRect.height / 2) - (mediaRect.top + mediaRect.height / 2);
    
    return (isNaN(x) || isNaN(y) || !isFinite(x) || !isFinite(y)) ? null : { x, y };
  }

  function getValidPosition() {
    let position = calculateInitialPosition();
    
    if (position === null) {
      void mediaElement.offsetHeight;
      void imageContainer?.offsetHeight;
      position = calculateInitialPosition();
    }
    
    if (position === null || (!position.x && !position.y)) {
      position = calculateViewportPosition();
    }
    
    return position;
  }

  function getInitialBorderRadius() {
    return window.innerWidth >= 768 ? "100px" : "20px";
  }

  function updateInitialPosition() {
    if (!mediaElement?.offsetWidth || !mediaElement?.offsetHeight) return;
    
    const position = getValidPosition();
    const currentScale = gsap.getProperty(mediaElement, "scale") || 0.10;
    const currentBorderRadius = gsap.getProperty(mediaElement, "borderRadius") || getInitialBorderRadius();
    
    gsap.set(mediaElement, {
      x: position.x,
      y: position.y,
      scale: currentScale,
      borderRadius: currentBorderRadius
    });

    scrollTriggerInstance && ScrollTrigger?.refresh();
  }

  function initAnimation() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      setTimeout(initAnimation, 100);
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    mediaElement = document.querySelector('#media');
    const sectionElement = mediaElement?.closest('.animated-image-section');
    imageContainer = document.querySelector('.image-container');
    
    if (!mediaElement || !sectionElement) return;

    gsap.set(mediaElement, { opacity: 0, visibility: "hidden" });

    const waitForReady = (attempts = 0) => {
      const elementsReady = (!imageContainer || (imageContainer.offsetWidth && imageContainer.offsetHeight)) &&
                            mediaElement.offsetWidth && mediaElement.offsetHeight;
      
      if (!elementsReady && attempts < 50) {
        requestAnimationFrame(() => waitForReady(attempts + 1));
        return;
      }
      
      const position = getValidPosition();

      gsap.set(mediaElement, {
        scale: 0.16,
        y: position.y,
        x: position.x,
        borderRadius: getInitialBorderRadius(),
        transformOrigin: "center center",
        force3D: true,
        opacity: 1,
        visibility: "visible"
      });

      scrollTriggerInstance = gsap.to(mediaElement, {
        scale: 1,
        y: 0,
        x: 0,
        borderRadius: "20px",
        ease: "power2.out",
        force3D: true,
        scrollTrigger: {
          trigger: sectionElement,
          start: "top top",
          end: "+=65%",
          scrub: 1,
          invalidateOnRefresh: true
        }
      });

      let resizeTimeout;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          // Update border radius on resize if needed
          const currentBorderRadius = gsap.getProperty(mediaElement, "borderRadius");
          const newBorderRadius = getInitialBorderRadius();
          if (currentBorderRadius !== newBorderRadius) {
            gsap.set(mediaElement, { borderRadius: newBorderRadius });
          }
          updateInitialPosition();
        }, 150);
      });
    };

    waitForReady();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initAnimation();
      initTextAnimation();
    });
  } else {
    setTimeout(() => {
      initAnimation();
      initTextAnimation();
    }, 100);
  }
})();
